const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/relocations/$organizationId/$projectId/$footageKey')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});